module.exports = __webpack_public_path__ + "img/ebook-hero-bg.df3298da.jpg";